//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 04.09.2015.
 */

(function () {

    'use strict';

    angular.module('container.core')
        .factory('Authorization', Authorization)
        // .factory('UserProfileResource', UserProfileResource)
        .factory('UserResource', UserResource)
        .factory('UserGroupResource', UserGroupResource)
        .factory('NotificationResource', NotificationResource)
        .factory('ConfigurationResource', ConfigurationResource)
        .factory('OperatorClientResource', OperatorClientResource)
        .factory('MockDevices', MockDevices)
        .factory('MockTask', MockTask)
        .factory('MockEntity', MockEntity)
        .factory('MockRemoteConnectTool', MockRemoteConnectTool)
        .factory('MockEvents', MockEvents)
        .factory('MockRules', MockRules)
        ;

    function Authorization($resource, CONTAINER_API_URL) {
        // return $resource(CONTAINER_API_URL + 'webapi/authorization/:action/:ident',
        return $resource(CONTAINER_API_URL + 'webapi/authorization/:action/:ident',
            {
                ident: '@ident'
            },
            {
                isAuthorizedActivity: {
                    method: 'GET',
                    params: { action: "activity" }
                },
                areAuthorizedActivities: {
                    method: 'GET',
                    params: { action: "activities" },
                    isArray: true
                }
            })
    }

    function UserResource($resource, CONTAINER_API_URL) {
        return $resource(CONTAINER_API_URL + 'webapi/users/:action',
            {
            },
            {
                getAssignedUserGroups: {
                    method: 'GET',
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined },
                    processData: false,
                    params: { action: "userGroups" },
                    isArray: true
                }
            }

        );
    }

    function NotificationResource($resource, CONTAINER_API_URL) {
        return $resource(CONTAINER_API_URL + 'webapi/notifications/:action/:id',
            {
                id: "@id"
            },
            {
                requestGrant: {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    params: { action: "requestGrant" }
                },
                requestMultipleGrants: {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    params: { action: "requestMultipleGrants" }
                }
            }

        );
    }

    function UserGroupResource($resource, CONTAINER_API_URL) {
        return $resource(CONTAINER_API_URL + 'webapi/userGroups/:id/:version/:action',
            {
                id: "@id",
                version: "@version"
            },
            {
                getUserGroups: {
                    method: 'GET',
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined },
                    processData: false,
                    isArray: true
                },
                getUnassignedUserGroups: {
                    method: 'GET',
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined },
                    processData: false,
                    params: { action: "unassigned" },
                    isArray: true
                },
                removeUserFromGroup: {
                    method: 'DELETE',
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': 'application/json' },
                    params: { action: "removeCurrentUser" }
                }
            }

        );
    }

    function ConfigurationResource($resource, CONTAINER_API_URL) {
        return $resource(CONTAINER_API_URL + 'webapi/configuration/:action', {},
            {
                getRegionalInstanceKey: {
                    method: 'GET',
                    params: { action: "regionalInstanceKey" }
                }
            })
    }

    function OperatorClientResource($resource, CONTAINER_API_URL) {
        return $resource(CONTAINER_API_URL + 'webapi/operatorClient/by-token', {},
            {
                get: {
                    method: 'GET',
                    headers: { 'skipRefresh': 'true' }
                }
            })
    }



    function MockDevices($resource) {
        return $resource('mock-devices/:id', { id: '@id' })
    }

    function MockTask($resource) {
        return $resource('mock-tasks/:id', { id: '@id' });
    }

    function MockEntity($resource) {
        return $resource('mock-entities/:id', { id: '@id' });
    }

    function MockRemoteConnectTool($resource) {
        return $resource('mock-remote-connect-tools/:id', { id: '@id' });
    }

    function MockEvents($resource) {
        return $resource('mock-events/:text', { text: '@text' });
    }

    function MockRules($resource) {
        return $resource('mock-rules/:text', { text: '@text' });
    }
})();
